import {ChangeDetectionStrategy, Component, HostBinding, Input, OnInit} from '@angular/core';

export interface TableColumn {
  displayName: string;
  columnName: string;
  hasSort?: boolean;
  sortProp?: string;
  minWidth?: string;
  width?: string;
  sortOrder?:string[]
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'table[appTable]',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataTableComponent implements OnInit {
  @HostBinding('class.data-table') class = true;
  @HostBinding('class.data-table--expandable') expandable = false;
  @HostBinding('class.data-table--scrollable') isScrollable = false;
  @HostBinding('class') sizeClass = '';

  @Input() size: 'sm' | 'md' = 'md';
  @Input() scrollable = false;

  constructor() {
  }

  ngOnInit(): void {
    this.sizeClass = `data-table--${this.size}`;
    this.isScrollable = this.scrollable;
  }

}
